export const environment = {
    environment: 'dev',
    msal: {
        cloudInstanceId: 'https://login.microsoftonline.com/',
        clientId: '6f4c0b8b-a991-41c3-9431-f5ab385519a4',
        tenantId: '2381cf1b-4fa9-428a-946f-b2483f3c289e',
        apiScope: 'api://6f4c0b8b-a991-41c3-9431-f5ab385519a4/SeaTools',
        baseScopes: ['openid', 'profile', 'email'],
    },
};
